import { getBreCode } from './bre';
import {
  assignTrigger,
  canTriggerBre,
  clearTrigger,
  createBre,
  listHandlerEntries,
} from './breModeling';

const MENU_ID = 'bre-assign';

/**
 * Context pad entry "Als BRE auslösen" on events that may throw one.
 *
 * The properties panel is where exceptions are managed; this is the short way
 * for the frequent move — marking the event you just drew. With no exception
 * described yet a single click creates the first one; otherwise a menu offers
 * the existing codes.
 */
export default function BreContextPadProvider(injector) {
  this._injector = injector;

  injector.get('contextPad').registerProvider(850, this);
  injector.get('popupMenu').registerProvider(MENU_ID, this);
}

BreContextPadProvider.$inject = ['injector'];

BreContextPadProvider.prototype.getContextPadEntries = function (element) {
  const injector = this._injector;
  if (!canTriggerBre(element)) return {};

  const linked = !!getBreCode(element);

  const entries = {
    'bre-assign': {
      group: 'edit',
      className: 'bpmn-icon-intermediate-event-catch-escalation',
      title: linked
        ? `Ausnahme ${getBreCode(element)} — ändern`
        : 'Als BRE auslösen',
      action: {
        click: (event, el) => {
          const target = el || element;
          const described = listHandlerEntries(injector.get('elementRegistry'));
          if (described.length === 0 && !linked) {
            // Nothing to choose from — the click creates the first exception.
            const created = createBre(injector, {});
            if (created) assignTrigger(injector, target, getBreCode(created));
            return;
          }
          injector.get('popupMenu').open(target, MENU_ID, {
            x: event.x || 0,
            y: event.y || 0,
          });
        },
      },
    },
  };
  return entries;
};

BreContextPadProvider.prototype.getPopupMenuEntries = function (target) {
  const injector = this._injector;
  const current = getBreCode(target);
  const entries = {};

  for (const handler of listHandlerEntries(injector.get('elementRegistry'))) {
    const code = getBreCode(handler);
    const name = handler.businessObject?.name || '';
    entries[`bre-use-${code}`] = {
      label: name && name !== code ? `${code} · ${name}` : code,
      className: code === current ? 'bre-menu-active' : '',
      action: () => assignTrigger(injector, target, code),
    };
  }

  entries['bre-new'] = {
    label: 'Neue Ausnahme anlegen…',
    className: 'bpmn-icon-start-event-none',
    action: () => {
      const created = createBre(injector, {});
      if (created) assignTrigger(injector, target, getBreCode(created));
    },
  };

  if (current) {
    entries['bre-clear'] = {
      label: 'Verknüpfung lösen',
      className: 'bpmn-icon-trash',
      action: () => clearTrigger(injector, target),
    };
  }

  return entries;
};

BreContextPadProvider.prototype.getPopupMenuHeaderEntries = function () {
  return {};
};
